// Added for chawk-bazar / ciseco: the default Next config sets `trailingSlash: true`, but backend urls
// (`seo.full_url`, route names) come without the trailing `/`, so every link costs a 308 redirect and
// JSON-LD gets a non-canonical url. Pure and isomorphic: safe in server and client code.

/**
 * Adds a trailing `/` to an internal path. Anything else is returned untouched:
 * non-strings, absolute urls (`https://…`, `//…`), paths with a query or hash, and paths that already end in `/`.
 */
export const with_trailing_slash = (href) => {
	if (typeof href !== "string" || !href.startsWith("/") || href.startsWith("//")) return href;
	if (/[?#]/.test(href) || href.endsWith("/")) return href;
	return `${href}/`;
};

// Extensions of files a page url never has: static assets and what scanners probe for (.php, .env, .sql ...).
const MEDIA_EXTENSION = /\.(?:html?|css|m?js|json|map|jpe?g|png|gif|webp|avif|svg|ico|bmp|tiff?|mp4|webm|mov|avi|mkv|mp3|wav|ogg|m4a|ttf|otf|woff2?|eot|txt|xml|csv|pdf|zip|rar|gz|tar|7z|docx?|xlsx?|pptx?|webmanifest|php\d?|aspx?|jsp|cgi|env|ini|cfg|conf|sql|bak|old|log|ya?ml|sh|exe|dll)$/i;

/**
 * Whether a request path is a file rather than a page (`init_page_server` answers it with a 404 without asking the
 * backend). Any `.` used to count, so a slug with a dot (`/products/nike-air-3.5/`, `/blogs/a.b/`) was a 404 too.
 * Now only a known file extension on the last segment, or a hidden segment (`/.env`, `/.git/config`), is a file.
 */
export const is_media_pathname = (pathname) => {
	if (typeof pathname !== "string" || !pathname) return false;
	const path = pathname.split(/[?#]/)[0];
	const segments = path.split("/").filter(Boolean);
	if (segments.some((segment) => segment.startsWith(".") && segment !== "." && segment !== "..")) return true;
	const last = segments[segments.length - 1] || "";
	return MEDIA_EXTENSION.test(last);
};
